import { ThemeKey } from '../theming-service';
import { Footprints, FootprintsStorageType } from './footprints';

export type EpdkFootprints = Footprints<typeof epdkFootprints>;

export const epdkFootprints = {
  sideBarWidth: {
    value: 0,
    storageType: FootprintsStorageType.Local
  },
  themeKey: {
    value: ThemeKey.LightModern,
    storageType: FootprintsStorageType.Local
  }
};